import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Ordi.png'
import _imports_1 from '@/assets/IconCreate.png'
import _imports_2 from '@/assets/IconSend.png'
import _imports_3 from '@/assets/IconActivate.png'


const _withScopeId = n => (_pushScopeId("data-v-4f8ff2c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid",
    "data-aos": "fade-up"
  })
], -1))
const _hoisted_4 = { class: "col-lg-6 col-sm-12 p-5" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h1 data-aos=\"fade-up\" data-v-4f8ff2c7>HOW DOES IT WORK?</h1><div class=\"float-start\" data-aos=\"fade-up\" data-v-4f8ff2c7><img src=\"" + _imports_1 + "\" class=\"TumiIcon\" data-v-4f8ff2c7></div><div class=\"TumiMargeLeft\" data-aos=\"fade-up\" data-v-4f8ff2c7><h2 data-v-4f8ff2c7>Make A project</h2><p data-v-4f8ff2c7> Once you have signed in, go to your portal and create a new project. Provide the email of the person who will be in charge of continuing the project, the best way to contact the client, and upload any necessary files that contain the credentials, file locations and documentation needed to complete the project.</p></div><div class=\"float-start\" data-aos=\"fade-up\" data-v-4f8ff2c7><img src=\"" + _imports_2 + "\" class=\"TumiIcon\" data-v-4f8ff2c7></div><div class=\"TumiMargeLeft\" data-aos=\"fade-up\" data-v-4f8ff2c7><h2 data-v-4f8ff2c7>Send the <span class=\"TumiOrange\" data-v-4f8ff2c7>ProjectLifeKey</span> to your client</h2><p data-v-4f8ff2c7> The app will then generate a unique digital key linked to your project. Send this key to you client by clicking on the send key button or give it to him directly. </p></div><div class=\"float-start\" data-aos=\"fade-up\" data-v-4f8ff2c7><img src=\"" + _imports_3 + "\" class=\"TumiIcon\" data-v-4f8ff2c7></div><div class=\"TumiMargeLeft\" data-aos=\"fade-up\" data-v-4f8ff2c7><h2 data-v-4f8ff2c7>The key is activated</h2><p data-v-4f8ff2c7> If your client needs to, they can activate their <span class=\"TumiOrange\" data-v-4f8ff2c7>ProjectLifeKey</span> on our website. An email will be sent to all parties involved to let them know that the key has been activated. After six days, if you have not objected to the activation of the key, all files and information related to the project will be made available to the person in charge of continuing the project.</p></div>", 7)
const _hoisted_12 = {
  "data-aos": "fade-up",
  class: "text-center"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Create your first ProjectLifeKey. It's free.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg",
    style: _normalizeStyle({'background-image' : 'url('+ require('@/assets/how.jpg') +')'}),
    id: "how"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: {path:'/SignUp'},
              class: "btn btn-info mt-4"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 4))
}